import React, { Component } from 'react';
import { Grid, withStyles, Typography } from '@material-ui/core';
import { withRouter } from 'react-router-dom';
import axios from 'axios';

import { WEB_API } from '../common/Constants';
import Container from '../component/div/Container';

import './Inquiry.css';

const styles = (theme) => ({
  wrapOuter: {
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
    justifyContent: 'center',
    position: 'absolute',
    top: '50%',
    left: '50%',
    transform: 'translate(-50%,-50%)',
    [theme.breakpoints.down('sm')]: {
      width: '80vw',
      height: '100%',
      margin: '0 auto',
      position: 'static',
      transform: 'translate(0)',
    },

    '& > div:first-child': {
      border: '1px solid #fff',
      padding: '10px 0',
      width: '300px',
      textAlign: 'center',
      fontSize: '2em',
      marginBottom: '50px',
      color: '#fff',
      [theme.breakpoints.down('sm')]: {
        width: '60%',
        padding: theme.spacing(1, 0),
        fontSize: '1.5em',
        marginBottom: theme.spacing(2.5),
      },
      [theme.breakpoints.down('xs')]: {
        width: '60%',
        padding: theme.spacing(0.8, 0),
        fontSize: '1.3em',
        marginBottom: theme.spacing(2),
      },
    },
  },
  wrap: {
    padding: '80px 90px',
    [theme.breakpoints.down('sm')]: {
      padding: '35px 30px',
      width: '100%',
    },
    [theme.breakpoints.down('sm')]: {
      padding: '30px 25px',
      width: '100%',
    },
  },
  imgWrap: {
    [theme.breakpoints.down('sm')]: {
      textAlign: 'center',
    },
  },
  innonLogo: {
    width: '50%',
    [theme.breakpoints.down('sm')]: {
      width: '70%',
    },
  },
  mainColor: {
    color: theme.palette.primary.main,
    verticalAlign: 'middle',
  },
  tr: {
    marginBottom: '10px',
    '&:last-child': {
      marginBottom: 0,
    },
    '& img': {
      marginRight: 10,
      width: '1.2em',
      [theme.breakpoints.down('sm')]: {
        fontSize: '1.1em',
      },
    },
    '& span': {
      fontWeight: 'bold',
      fontSize: '1.2em',
      [theme.breakpoints.down('sm')]: {
        fontSize: '1.1em',
      },
    },
  },
  td: {
    color: theme.typography.color,
    fontSize: '1.1em',
    [theme.breakpoints.down('sm')]: {
      fontSize: '1em',
    },
    [theme.breakpoints.down('xs')]: {
      fontSize: '0.9em',
    },
  },
  webAddress: {
    paddingBottom: 50,
    fontSize: '1.3em',
    color: theme.typography.color,
    [theme.breakpoints.down('sm')]: {
      paddingBottom: 30,
      fontSize: '1em',
    },
    [theme.breakpoints.down('xs')]: {
      paddingBottom: 20,
      fontSize: '0.8em',
    },
  },
  mobileNoPaddingTop: {
    [theme.breakpoints.down('sm')]: {
      paddingTop: '0 !important',
    },
  },
  mobilePaddingBottom: {
    [theme.breakpoints.down('sm')]: {
      paddingBottom: `${theme.spacing(1)}px !important`,
    },
  },
});

class Inquiry extends Component {
  constructor(props) {
    super(props);
    this.state = {
      addr: '',
      addrEn: '',
      email: '',
      fax: '',
      tel: '',
    };
  }

  componentDidMount() {
    this.getContacts();
  }

  getContacts() {
    axios
      .get(`${WEB_API}/home/client/innon`, {
        headers: {
          Pragma: 'no-cache',
        },
      })
      .then((res) => {
        for (const [key, value] of Object.entries(res.data.Item)) {
          this.setState({ [key]: value });
        }
      });
  }

  render() {
    const { classes } = this.props;
    const { addr, addrEn, email, fax, tel } = this.state;

    return (
      <Container currentPath={this.props.location.pathname}>
        <div
          style={{
            backgroundImage: `url('images/background/inquiry_bg.png')`,
            backgroundSize: '100% 100%',
            backgroundRepeat: 'no-repeat',
            backgroundPosition: 'center right',
            width: '100%',
            height: '100%',
            position: 'relative',
            overflowY: 'hidden',
            overflowX:'hidden'
          }}
        >
          <div className={classes.wrapOuter} id={'wrap-outer'}>
            <div>Contact us</div>
            <div style={{ backgroundColor: '#fff' }} className={classes.wrap} id={'wrap'}>
              <div className={classes.imgWrap}>
                <img src="images/innon_logo_horizontal@2x.png" alt="innon_logo_horizontal" className={classes.innonLogo} />

                <Typography variant="subtitle1" component="h1" className={classes.webAddress} id={'web-addr'}>
                  www.innon.co.kr
                </Typography>
              </div>

              <Grid container direction="column">
                <Grid container spacing={3} alignItems="flex-start" className={classes.tr}>
                  <Grid item xs={12} md={3} className={`${classes.mainColor} ${classes.mobilePaddingBottom}`} container alignItems="center">
                    <img src="images/icon/ic_building@2x.png" alt="ic_building" /> <span>Address</span>
                  </Grid>
                  <Grid item xs={12} md={9} className={`${classes.td} ${classes.mobileNoPaddingTop}`}>
                    {addr && addr}
                    <br /> {addrEn && addrEn}
                  </Grid>
                </Grid>
                <Grid container alignItems="center" className={classes.tr}>
                  <Grid item xs={5} md={3} className={classes.mainColor} container alignItems="center">
                    <img src="images/icon/ic_phone@2x.png" alt="ic_phone" /> <span>Tel</span>
                  </Grid>
                  <Grid item xs={7} md={9} className={classes.td}>
                    {tel && tel}
                  </Grid>
                </Grid>
                <Grid container alignItems="center" className={classes.tr}>
                  <Grid item xs={5} md={3} className={classes.mainColor} container alignItems="center">
                    <img src="images/icon/ic_fax@2x.png" alt="ic_fax" />
                    <span>Fax</span>
                  </Grid>
                  <Grid item xs={7} md={9} className={classes.td}>
                    {fax && fax}
                  </Grid>
                </Grid>
                <Grid container alignItems="center" className={classes.tr}>
                  <Grid item xs={5} md={3} className={classes.mainColor} container alignItems="center">
                    <img src="images/icon/ic_email@2x.png" alt="img" />
                    <span>E-mail</span>
                  </Grid>
                  <Grid item xs={7} md={9} className={classes.td}>
                    {email && email}
                  </Grid>
                </Grid>
              </Grid>
            </div>
          </div>
        </div>
      </Container>
    );
  }
}

export default withRouter(withStyles(styles, { withTheme: true })(Inquiry));
